module.exports = __webpack_public_path__ + "391ee3c4cba643f137c4315cd5044256.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/palm-tree.png
// module id = 982
// module chunks = 0